export async function loadBaseMover(engine, refresh = true) {
    await engine.addMover("base", async () => {
        const { BaseMover } = await import("./BaseMover.js");
        return new BaseMover();
    }, refresh);
}
